import { useCarePlanContext } from "../care-plan";
import { CarePlanTagDisplay } from "../tag-display";
import { useQuery } from "@tanstack/react-query";

import { cx } from "@/lib/tailwind-utils";

import { useBranch } from "./branch";
import { carePlanTagQueryOptions } from "@/api/provider/settings/care-plan-tag-query";

export function BranchLabel() {
  const {
    config: { size },
  } = useCarePlanContext();
  const { branch, isSelected } = useBranch();
  const { data: allTags } = useQuery(carePlanTagQueryOptions.list());

  const branchTags = allTags?.filter((t) => branch.tagIds.includes(t.id));

  return (
    <div
      data-care-plan-branch-label
      className="flex flex-col items-center justify-center gap-1 py-1 w-24"
    >
      <div data-care-plan-branch-heading className="flex items-center gap-2">
        <div
          className={cx(
            "h-2 w-2 rounded-full shrink-0",
            isSelected ? "bg-primary" : "bg-foreground-muted",
          )}
        />
        <span
          data-care-plan-branch-name
          className={cx(
            "font-medium truncate",
            isSelected ? "text-foreground" : "text-foreground-secondary",
            size === "sm" ? "text-tiny" : "text-caption",
          )}
        >
          {branch.name || `Option ${branch.position + 1}`}
        </span>
      </div>
      {branchTags && branchTags.length > 0 && (
        <CarePlanTagDisplay tags={branchTags} max={size === "sm" ? 1 : 2} />
      )}
    </div>
  );
}
